export default __webpack_public_path__ + "static/media/bayadAppLogo.17a97c08.svg";